import { AdminTemplate, MerchantCommissionsByBankFilter } from "../../components";

export const MerchantCommissionsByBank = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Komisyon Oranları",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
        <MerchantCommissionsByBankFilter />
    </AdminTemplate>
  );
};
